package xyz.luan.bpc

import kotlin.math.pow
import kotlin.math.round

fun inverse(value: Double): Double = "$value".reversed().toDouble()

fun roundTo(value: Double, places: Int): Double {
    val factor = 10.0.pow(places)
    return round(value / factor) * factor
}
